var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxClipboardClock = function Svg18PxClipboardClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.75 8.338V4.75a2 2 0 0 0-2-2h-1M6.25 2.75h-1a2 2 0 0 0-2 2v9.5a2 2 0 0 0 2 2h3.202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.75 1.25h-3.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1M6.25 11.75h2M6.25 8.75h4M13.75 17.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.906 14.476 13.75 14v-1.25"
  })));
};
export default Svg18PxClipboardClock;